/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import {
    DataTable, TableContainer, Table, TableHead,
    TableRow, TableHeader, TableBody, TableCell, TableToolbar,
    TableToolbarContent, TableToolbarSearch, TableExpandRow, TableExpandedRow, TableExpandHeader, Pagination
} from 'carbon-components-react'
import TableToolbarDownload from 'common/TableToolbarDownload';
import ParentTask from 'assets/image/ParentTask.svg';


const DigitalWorkerTaskTable = (props) => {
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [filteredRows, setFilteredRows] = useState([]);

    useEffect(() => {
        let rows = props.rows;
        setFilteredRows(rows);
        setTotalItems(rows ? rows.length : 0);
        getPaginatedRows();
    }, [props.rows])

    function getPaginatedRows(param) {
        if(filteredRows.length) {
            let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
            let slicedRows = filteredRows.slice(startingIndex,startingIndex + currentPageSize);
            setPaginatedRows(slicedRows);
        }
    }

    const hasParent = (rowId) => {
        const row = props.rows.find(({ id }) => id === rowId);
            
        if(row && row.child_flag === "Y"){
            return true;
        }else {
            return false;
        }
        
    };

    // const displayCell = (cell, currentRow) => {
    //     let currentHeader = props.headers.filter(function (header) { return header.key === cell.info.header });
        
    //         switch (cell.info.header) {
    //             case "task_name":
    //                 if (hasParent(currentRow.id)) {
    //                     return <TableCell key={cell.id}><div className='queue-status'><div><img className='queue-img' src={ParentTask} /></div><div className="queue-text">{cell.value}</div></div></TableCell>
    //                 }
    //             default:
    //                 return <TableCell key={cell.id}>{cell.value}</TableCell>
    //         }
    // }

    return (
        <>
            {filteredRows.length ?
                <div>
                <DataTable size="tall" rows={filteredRows} headers={props.headers} render={({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getBatchActionProps,
                    onInputChange }) => (
                    <TableContainer>
                        <TableToolbar>
                            <TableToolbarContent>
                                <TableToolbarSearch
                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                    onChange={onInputChange}
                                />
                                <TableToolbarDownload iconDescription='Export' rows={filteredRows} headers={props.headers} title="Alerts" filename="export" label="Download" />
                            </TableToolbarContent>
                        </TableToolbar>
                        <Table {...getTableProps()}>
                            <TableHead>
                                <TableRow>
                                    {props.isExpandable && <TableExpandHeader />}
                                    {headers.map(header => (
                                        header.header && <TableHeader {...getHeaderProps({ header })}>
                                            {header.header}
                                        </TableHeader>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, i) => (
                                    props.isExpandable
                                    ?
                                    <React.Fragment key={row.id}>
                                        <TableExpandRow {...getRowProps({ row })}>
                                        {row.cells.map(cell => (
                                            <TableCell key={cell.id}>{cell.value}</TableCell>
                                        ))}
                                        </TableExpandRow>
                                        {row.isExpanded && (
                                        <TableExpandedRow colSpan={headers.length + 1}>
                                            <div className="exception-tag carbon-display-Semibold-14">Exception tag</div>
                                            <div className="carbon-display-Regular-14">
                                                SAP - Red error message appeared - Vendor 1352 not yet created by purchasing organization CH70
                                            </div>
                                        </TableExpandedRow>
                                        )}
                                    </React.Fragment>
                                    :
                                    <TableRow key={"row" + i} {...getRowProps({ row })}>
                                        {row.cells.map((cell, index) => (
                                            <TableCell key={"cell" + index + i}>
                                                {cell.value}
                                            </TableCell>
                                            // displayCell(cell, row)

                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>)}
                />
                <Pagination
                    totalItems={totalItems}
                    backwardText="Previous page"
                    forwardText="Next page"
                    pageSize={currentPageSize}
                    pageSizes={[5, 10, 15, 25]}
                    itemsPerPageText="Items per page"
                    onChange={({ page, pageSize }) => {
                        if (pageSize !== currentPageSize) {
                            setCurrentPageSize(pageSize);
                        }
                        let newFirstRowIndex = pageSize * (page - 1);
                        setFirstRowIndex(newFirstRowIndex)
                        getPaginatedRows(newFirstRowIndex);
                    }}
                />
                </div>
                :
                <div className="message carbon-display-Semibold-14">No data available</div>
            }
        </>
    );
}
export default DigitalWorkerTaskTable
